import React, {useState} from 'react';
import { Navbar } from './components/navbar/navbar.js'
import { Dashboard } from './pages/dashboard/dashboard.js';
import {Campaign} from './pages/campaign/campaign.js';
import { FlowsDetail } from './pages/flows-detail/flowsDetail.js';
import { Login } from './pages/login/login.js';
import './App.css';
import { Sidebar } from './components/sidebar/sidebar.js';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CampaignCreate } from './pages/campaign-create/campaign-create.js';
import { CampaignDetail } from './pages/campaign-detail/campaign-detail.js';
import { Flows } from './pages/flows/flows.js';
import { Audience } from './pages/audience/audience.js';
import { SegmentDetail } from './pages/segement-detail/segment-detail.js';
import { AuthProvider } from "./backend/authContext";
import ProtectedRoute from "./backend/protectedRoute.js";
import MainLayout from './layouts/MainLayout';

function App() {
    const [isEnabled, setIsEnabled] = useState(false);

    var metricData = {
        "value1": 24
    }

    const handleSliderToggle = () => {
        setIsEnabled(!isEnabled);
        metricData["value1"] = 25;
    };

    return (
        <AuthProvider>
        <Router>
            <div className="app-container">
                <div className="navbar-container">
                    <Navbar />
                </div>
                <div className="main">
                    <Routes>
                        <Route>
                            <Route path="/login" element={<Login />} />
                        </Route>
                        
                        {/* Main app routes with full layout */}
                        <Route element={<MainLayout />}>
                            <Route path="/" element={
                                <ProtectedRoute> <Campaign /> </ProtectedRoute>
                            } />
                            <Route path="/campaign" element={
                                <ProtectedRoute> <Campaign /> </ProtectedRoute>
                            } />
                            <Route path="/dashboard" element={
                                <ProtectedRoute> <Dashboard metricData={metricData} showMetrics={true} /> </ProtectedRoute>
                            } />
                            <Route path="/flows" element={
                                <ProtectedRoute> <Flows /> </ProtectedRoute>
                            } />
                            <Route path="/flows/flows-detail" element={
                                <ProtectedRoute> <FlowsDetail /> </ProtectedRoute>
                            } />
                            <Route path="/create-campaign/email" element={
                                <ProtectedRoute> <CampaignCreate /> </ProtectedRoute>
                            } />
                            <Route path="/campaign/detail" element={
                                <ProtectedRoute> <CampaignDetail /> </ProtectedRoute>
                            } />
                            <Route path="/audience" element={
                                <ProtectedRoute> <Audience /> </ProtectedRoute>
                            } />SegmentDetail
                            <Route path="/segment/detail" element={
                                <ProtectedRoute> <SegmentDetail /> </ProtectedRoute>
                            } />
                        </Route>
                    </Routes>
                </div>
            </div>
        </Router>
        </AuthProvider>
    );
}

export default App;
